var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "btmWrap",
    class: _vm.status.issueListViewBln ? 'active' : null
  }, [_c('button', {
    staticClass: "isueList",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.toggleHandler.apply(null, arguments);
      }
    }
  }, [_vm._v(_vm._s(`${_vm.isProtocol ? '이슈리스트' : '실험타입'}`))])]);

}
var staticRenderFns = []

export { render, staticRenderFns }